
import { defineComponent } from 'vue';
import BytecookieLogo from '@/components/svg-components/BytecookieLogo.vue';
import X from '@/components/svg-components/X.vue';
import BCXIcon from '@/components/molecules/BCXIcon.vue';

export default defineComponent({
  name: 'LRPopupMobileHeader',
  components: { BytecookieLogo, X, BCXIcon },
  props: {
    showCopyIcon: Boolean
  },
  emits: ['click', 'copy']
});
